<template>
  <div class="flex justify-between article-card">
    <h3 v-if="category" class="article-category">
      {{ category }}
    </h3>
    <h3 class="article-title">
      {{ title }}
    </h3>
    <div class="flex gap-3 article-actions">
      <TButton
        class="view-btn"
        label="View"
        icon="outlineEye"
        @click="() => viewArticle(careTeamDocumentId)"
      />
      <TButton
        class="flex items-center gap-2"
        label="Copy Link"
        :icon="showCheckmark ? 'check' : 'square2Stack'"
        @click="() => copyLink(connectSourceUrl)"
      />
    </div>
  </div>
</template>

<script lang="ts">
import TButton from '@thyme/nashville/src/components/button/TButton.vue'
import { defineComponent } from 'vue'
import setup from './controller'
import { ARTICLE_CARD_PROPS } from './types'

export default defineComponent({
  components: { TButton },
  props: ARTICLE_CARD_PROPS,
  setup,
})
</script>

<style lang="scss" scoped>
.article-actions :deep(button > svg) {
  margin-right: 0.5rem;
}

.article-card {
  @apply p-4 items-center;
  @apply border border-nash-neutral400 rounded-lg;
  @apply bg-nash-neutral000 text-nash-neutral900;
  @apply text-base font-medium;
}

.article-category {
  @apply mr-4 mb-2 text-nash-neutral700 text-base font-medium;
}

.article-title {
  @apply flex-1 mr-4 text-nash-neutral900 text-base font-medium;
}
</style>
